import { sequencesFactory } from '@eas/common-web';

export const Sequences = sequencesFactory(
  '/api/evidence-spisu/sequences',
  null
);
